import { getAppConfig } from "@vega-core/utils/appConfig";
import { isLocal, isMSW } from "@vega-core/utils/global";

const DEFAULT_POSTHOG_HOST = "https://eu.i.posthog.com";

export type PostHogConfig = {
  enabled: boolean;
  key: string | undefined;
  host: string;
  projectId: string | undefined;
  sessionRecordingEnabled: boolean;
};

const readEnvFlag = (value: string | undefined): boolean => value === "true";

export function getPostHogConfig(): PostHogConfig {
  const { posthogKey, posthogHost, posthogEnabled, posthogProjectId } =
    getAppConfig();

  const key = posthogKey || undefined;
  const host = posthogHost || DEFAULT_POSTHOG_HOST;
  const projectId = posthogProjectId || undefined;
  const sessionRecordingEnabled =
    import.meta.env.VITE_POSTHOG_SESSION_RECORDING !== "false";
  const flagEnabled = readEnvFlag(posthogEnabled);

  return {
    enabled: flagEnabled && Boolean(key) && !isExcludedRuntime(),
    key,
    host,
    projectId,
    sessionRecordingEnabled,
  };
}

function isExcludedRuntime(): boolean {
  if (import.meta.env.IS_VITEST) return true;

  if (isLocal()) return true;

  if (getAppConfig().mode === "local") return true;

  if (isMSW) return true;

  return false;
}

export const isPostHogEnabled = (): boolean => getPostHogConfig().enabled;
